import React, { Component } from 'react'

import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'

import Loading from '../../components/shared/Loading'

import { ResetPasswordForm } from './ResetPasswordForm'
import { Message } from './Message'

import { verifyInviteToken, completeInvite } from '../../../lib/authentication'

import { isComplexPassword, createPasswordComplexityList } from '../complexity'
import { createIdentityMap, getPossibleInviteToken, getPasswordPolicyComplexity } from '../utils'

import routes from '../../constants/routes'
import { Banner } from './Banner'
import './auth.scss'

const Stages = createIdentityMap(
  'VERIFYING_INVITE_TOKEN',
  'INVALID_INVITE_TOKEN',
  'ENTERING_NEW_PASSWORD',
  'SUBMITTING_NEW_PASSWORD',
  'VALID_NEW_PASSWORD',
  'INVALID_NEW_PASSWORD',
)

export default class CompleteInvite extends Component {
  constructor(props) {
    super(props)

    this.state = {
      newPassword: '',
      confirmPassword: '',
      passwordComplexity: {},
      username: '',
      error: { errorSummary: '', errorItems: [] },
      stage: Stages.VERIFYING_INVITE_TOKEN,
    }
  }

  componentDidMount() {
    this.handleVerifyInviteToken()
  }

  get inviteToken() {
    return getPossibleInviteToken(this.props.location)
  }

  setPasswordComplexity(passwordComplexity = {}) {
    this.setState({ passwordComplexity })
  }

  setUsername(username = '') {
    this.setState({ username })
  }

  setError(errorSummary, ...errorItems) {
    this.setState({ error: { errorSummary, errorItems } })
  }

  setStage(stage) {
    this.setState({ stage })
  }

  isOnStage(...stages) {
    return stages.includes(this.state.stage)
  }

  getComplexityList = () => {
    const { username, newPassword, passwordComplexity } = this.state
    return createPasswordComplexityList(passwordComplexity, newPassword, username)
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  //TODO: If token is not valid, we (currently) display a message stating as such
  handleVerifyInviteToken = async () => {
    this.setStage(Stages.VERIFYING_INVITE_TOKEN)
    const { username, policy } = await verifyInviteToken(this.inviteToken)
    const isVerified = !!policy

    isVerified && this.setPasswordComplexity(getPasswordPolicyComplexity(policy))
    this.setUsername(username)
    this.setStage(isVerified && Stages.ENTERING_NEW_PASSWORD || Stages.INVALID_INVITE_TOKEN)
  }

  //TODO: Well crap, "logged in" in this app means "state.user is not empty"
  // Which we can't do anything about.
  handleSubmitForm = async (event) => {
    event.preventDefault()

    this.setError()
    this.setStage(Stages.SUBMITTING_NEW_PASSWORD)

    const { success, error } = await completeInvite(this.inviteToken, this.state.newPassword)

    if (!success && error) {
      const { errorSummary = '', errorItems = [] } = error
      this.setError(errorSummary, ...errorItems)
      this.setStage(Stages.INVALID_NEW_PASSWORD)
      return
    }

    if (success && !error) {
      this.setStage(Stages.VALID_NEW_PASSWORD)
      return
    }

    this.setError('Unknown Error occurred, please try again')
    this.setStage(Stages.ENTERING_NEW_PASSWORD)
  }

  validateForm = () => {
    const { username, newPassword, confirmPassword, passwordComplexity } = this.state
    const isPasswordMatch = newPassword === confirmPassword
    return isComplexPassword(passwordComplexity, newPassword, username) && isPasswordMatch
  }

  renderForm() {
    const { newPassword, confirmPassword } = this.state
    return (
      <ResetPasswordForm
        title="Choose a New Password"
        onSubmit={this.handleSubmitForm}
        onChange={this.handleChange}
        validateForm={this.validateForm}
        complexityList={this.getComplexityList}
        newPassword={newPassword}
        confirmPassword={confirmPassword}
      >
        {this.isOnStage(Stages.INVALID_NEW_PASSWORD) && this.renderErrors()}
      </ResetPasswordForm>
    )
  }

  renderErrors() {
    const { error: { errorSummary = 'Unknown Error Ocurred', errorItems = [] } = {} } = this.state
    return (
      <Message title={errorSummary} type="danger">
        {errorItems.map(errorItem => (<p key={btoa(errorItem)}>{errorItem}</p>))}
      </Message>
    )
  }

  redirectInvalidInviteTokenMessage() {
    return (
      <Redirect
        to={{
          pathname: "/login",
          state: { from: 'inviteToken' }
        }}
      />
    )
  }

  render() {
    return (
      <div className="AuthContainer vertical">
        <Banner username={this.state.username} />
        {this.isOnStage(Stages.VERIFYING_INVITE_TOKEN, Stages.SUBMITTING_NEW_PASSWORD) && <Loading classes="loading" />}
        {this.isOnStage(Stages.ENTERING_NEW_PASSWORD, Stages.INVALID_NEW_PASSWORD) && this.renderForm()}
        {this.isOnStage(Stages.VALID_NEW_PASSWORD) && <Loading classes="loading" /> }
        {this.isOnStage(Stages.INVALID_INVITE_TOKEN) && this.redirectInvalidInviteTokenMessage()}
      </div>
    )
  }
}
